@if (Vendor && Company && ComplianceSetting) {
  <app-display-card>
    <div class="ins-policies-head">
      <h3 class="mb-0">Insurance policies</h3>
    </div>

    <div class="ins-policies">
      @for (PolicyType of PolicyTypes; track PolicyType) {
        @if (
          (ComplianceSetting[
            PolicyTypeToPolicyRequirementSetting[PolicyType]
          ] ||
            PolicyTypeToInsurancePolicyMap[PolicyType]) &&
          ((PolicyType !== 'PL' &&
            (Vendor.hasNonProfessionalTrade ||
              Vendor.hasProfessionalOrNonProfessionalTrade)) ||
            (PolicyType === 'PL' &&
              (Vendor.hasProfessionalTrade ||
                Vendor.hasProfessionalOrNonProfessionalTrade)))
        ) {
          <div class="ins-findings inner-panel rounded">
            <div class="ins-findings__title">
              <span class="ins-findings__eyebrow">Policy</span>
              <span class="ins-findings__name">
                {{ PolicyTypeToPolicyLabelMap[PolicyType] }}
              </span>
            </div>

            <div class="ins-findings__head">
              <div class="ins-findings__col">Field</div>
              <div class="ins-findings__col">Finding</div>
              <div class="ins-findings__col ins-findings__col--center">
                Requirements
              </div>
              <div class="ins-findings__col ins-findings__col--center">
                Result
              </div>
            </div>

            @if (
              Company.country === 'CA' &&
              PolicyType === 'WC' &&
              CanadianWorkersCompensationFindingAndResults.length > 0
            ) {
              @for (
                CanadianWorkersCompensationFindingAndResult of CanadianWorkersCompensationFindingAndResults;
                track CanadianWorkersCompensationFindingAndResult
              ) {
                <div class="ins-findings__row">
                  <div class="ins-findings__col">
                    {{ CanadianWorkersCompensationFindingAndResult.name }}
                    coverage passes all client requirements?
                  </div>
                  <div class="ins-findings__col">
                    {{ CanadianWorkersCompensationFindingAndResult.finding }}
                  </div>
                  <div class="ins-findings__col ins-findings__col--center">
                    {{
                      ComplianceSetting.workersCompensation_isRequired
                        ? 'Required'
                        : 'Not required'
                    }}
                  </div>
                  <div class="ins-findings__col ins-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{ CanadianWorkersCompensationFindingAndResult.result }}
                    </span>
                  </div>
                </div>
              }
            }

            @for (
              PolicyResult of getPolicyTypeResult(PolicyType);
              track PolicyResult
            ) {
              @if (
                ComplianceResults[PolicyResult] &&
                !(Company.country === 'CA' && PolicyType == 'WC') &&
                (ComplianceResults[PolicyResult] !== 'NOT REQUIRED' ||
                  (ComplianceResults[PolicyResult] === 'NOT REQUIRED' &&
                    PolicyTypeToInsurancePolicyMap[PolicyType] &&
                    getFormattedFindingValue(
                      PolicyTypeToInsurancePolicyMap[PolicyType]![
                        ComplianceResultToLabelMap[PolicyResult].finding
                      ]
                    )))
              ) {
                <div class="ins-findings__row">
                  <div class="ins-findings__col">
                    {{ ComplianceResultToLabelMap[PolicyResult].label }}
                  </div>
                  <div class="ins-findings__col">
                    @if (PolicyTypeToInsurancePolicyMap[PolicyType]) {
                      {{
                        getFormattedFindingValue(
                          PolicyTypeToInsurancePolicyMap[PolicyType]![
                            ComplianceResultToLabelMap[PolicyResult].finding
                          ]
                        )
                      }}
                    }
                  </div>
                  <div class="ins-findings__col ins-findings__col--center">
                    {{ getPolicySettingValue(PolicyResult) }}
                  </div>
                  <div class="ins-findings__col ins-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{ ComplianceResults[PolicyResult] }}
                    </span>
                  </div>
                </div>
              }
            }
          </div>
        }
      }
    </div>
  </app-display-card>
}
